<template>
    <div class="axiosyAxios chartConfig_viewDP">
        <!--次轴-->
        <div v-if="config.axios.yAxios.yAxios[1]">
            <div class="chartDivConfig checkViewConfig" v-if="nowChart.name==='双轴图'">
                <el-checkbox v-model="config.axios.yAxios.yAxios[1].show" @change="getRender">是否展示次轴</el-checkbox>
            </div>

            <div class="chartDivConfig checkViewConfig"  >
                <el-checkbox v-model="config.axios.yAxios.yAxios[1].splitLine.show" @change="getRender">是否显示分隔线</el-checkbox>
            </div>
            <div class="chartDivConfig colViewConfig"  >
                <span class="span_til">分隔线颜色</span>
                <el-color-picker v-model="config.axios.yAxios.yAxios[1].splitLine.lineStyle.color[0]" show-alpha @change="getRender"></el-color-picker>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit">
                <span class="span_til">分隔线宽度</span>
                <el-input v-model="config.axios.yAxios.yAxios[1].splitLine.lineStyle.width" @change="getRender" type="number" min="0"></el-input>
                <div class="unit">px</div>
            </div>
            <div class="chartDivConfig selViewConfig">
                <span class="span_til">分隔线类型</span>
                <el-select v-model="config.axios.yAxios.yAxios[1].splitLine.lineStyle.type" placeholder="请选择分隔线类型"
                           :popper-append-to-body="false" @change="getRender">
                    <el-option
                            v-for="item in lineList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="chartDivConfig colViewConfig">
                <span class="span_til">轴线颜色</span>
                <el-color-picker v-model="config.axios.yAxios.yAxios[1].axisLine.lineStyle.color" show-alpha @change="getRender"></el-color-picker>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit">
                <span class="span_til">轴线线宽</span>
                <el-input v-model="config.axios.yAxios.yAxios[1].axisLine.lineStyle.width" @change="getRender" type="number" min="0"></el-input>
                <div class="unit">px</div>
            </div>
            <div class="chartDivConfig checkViewConfig">
                <el-checkbox v-model="config.axios.yAxios.yAxios[1].axisTick.show" @change="getRender">是否显示坐标轴刻度</el-checkbox>
            </div>
            <div class="chartDivConfig checkViewConfig">
                <el-checkbox v-model="config.axios.yAxios.yAxios[1].axisTick.inside" @change="getRender">坐标轴刻度是否朝内</el-checkbox>
            </div>

            <div class="chartDivConfig checkViewConfig">
                <el-checkbox v-model="config.axios.yAxios.yAxios[1].axisLabel.show" @change="getRender">是否显示坐标轴文字</el-checkbox>
            </div>
            <div class="chartDivConfig colViewConfig" >
                <span class="span_til">字体颜色</span>
                <el-color-picker v-model="config.axios.yAxios.yAxios[1].axisLabel.color" show-alpha @change="getRender"></el-color-picker>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit" >
                <span class="span_til">字体大小</span>
                <el-input v-model="config.axios.yAxios.yAxios[1].axisLabel.fontSize" @change="getRender" type="number" min="12"></el-input>
                <div class="unit">px</div>
            </div>
            <div class="chartDivConfig numViewConfig numViewConfig_unit" >
                <span class="span_til">文字角度</span>
                <el-input v-model="config.axios.yAxios.yAxios[1].axisLabel.rotate" @change="getRender" type="number" min="0"></el-input>
                <div class="unit">度</div>
            </div>
            <div class="chartDivConfig numViewConfig " >
                <span class="span_til">起始值</span>
                <el-input v-model="config.axios.yAxios.yAxios[1].min" @change="getRender" type="number" ></el-input>
            </div>

        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/27 5:58 下午
     */
    export default {
        name: 'axiosyAxios',
        components: {},
        props: {
            name: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                AxisType:'Y',
                typeList:[
                    {value: 'category', label: '类目轴'},
                    {value: 'value', label: '数值轴'},
                ],
                lineList:[
                    {value: 'solid', label: '实线'},
                    {value: 'dashed', label: '虚线'},
                    {value: 'dotted', label: '点线'},
                ]
            }
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
            nowChart() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.nowChart;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart;
                }
            }
        },
        watch: {

        },
        methods: {
            get() {
                yAxisCustom[1].splitLine.show = !yAxisCustom[0].splitLine.show;
            },
            getType() {
                if(this.nowChart.name==='条形图'){
                    this.AxisType = 'X';
                }else{
                    this.AxisType = 'Y';
                }
            },
            // config.axios.yAxios[1].splitLine.show
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {
            this.getType();
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .axiosyAxios {
        .chartDivConfig {
            .span_til {
                width: 28%!important;
                max-width: 74px !important;
            }
        }
    }
</style>